
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-26 11:12:08
-->
<template>
  <div>
    <el-drawer
      title="统计配置"
      :visible.sync="visibleTwo"
      @closed="closeTwo"
      :destroy-on-close="true"
      size="535px"
      class="drawer-box"
      :with-header="true"
    >
       <a-spin :spinning="appLoading">
    <div class="applay-box">
        <div class="title-box">
            <i class="el-icon-info icon-title"></i>
            <div>
            按需将所需统计的组织设定在一张统计表上，后续查看统计数据时可按不同统计表进行筛选统计和导出
            </div>
        </div>
        <coententTable
        :columns="columnsTwo"
        :dataSource="dataSourceColunm"
        :customSlot="customSlotTwo"
         :y="300"
      >
         <template v-slot:operation="scopeVal">
           <div style="display: flex;">
                <div
            class="btnTwo"
             v-if="codeData.indexOf('402') != -1"
            @click="updateConfig(scopeVal.scope)"
            >编辑</div
          >
          <div
           @click="dele(scopeVal.scope)"
            v-if="codeData.indexOf('404') != -1"
            style="margin-left: 20px"
            class="btnThree"
            >删除</div
          >
           </div>
        </template>
      </coententTable>
      <el-button
          @click="addConfig"
          type="primary"
          size="small"
          v-if="codeData.indexOf('401') != -1"
           style="margin-right: 12px;margin-top:20px"
          >新增配置</el-button
        >
    </div>
  </a-spin>
  
    </el-drawer>
    <el-dialog
      title="新增配置"
      :visible.sync="visibleTips"
      width="535px"
      custom-class="tips-box"
      :before-close="handleClose"
      top="17%"
    >
      <a-spin :spinning="loading">
        <el-form
        :label-width="'70px'"
        class="demo-ruleForm"
      >
                <el-form-item label="表名称">
                <el-input
                    size="small"
                    v-model="modelName"
                    placeholder="请输入名称，不超过10个字符"
                ></el-input>
                </el-form-item>
                <el-form-item label="统计组织">
                  <div class="tree-box">
                        <a-tree
                            :expanded-keys="expandedKeys"
                            v-model="checkedKeys"
                            :auto-expand-parent="autoExpandParent"
                            checkable
                            :checkStrictly="true"
                            @check="onSelect"
                            :tree-data="treeData"
                            @expand="onExpand"
                        />
                    </div>
                </el-form-item>
            </el-form>
            <div class="dis-box">
                <el-button
                @click="handleClose"
                class="submit"
                size="small"
                >取消</el-button
                >
                <el-button
                :loading="submitLoading"
                @click="submitBtn"
                class="submit"
                size="small"
                type="primary"
                >保存</el-button
                >
      </div>
          </a-spin>
           
    </el-dialog>
     <el-dialog
            title="删除评分标准？"
            :visible.sync="dialogVisibleTwo"
            width="450px"
            class="tips-box"
            top="17%"
          >
            <span>删除后，已使用该标准进行评分的稿件将不计入统计表中。</span>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="dialogVisibleTwo = false">取消</el-button>
              <el-button size="small" :loading="deleteShow" type="danger" @click="deleteOne()">确认删除</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {tree,selectList,selectListCreate,selectListUpdate,update,deleteTable} from "./index";
export default {
  data() {
    return {
      visibleTwo: false,
      appLoading: false,
      loading:false,
      expandedKeys: [],
      checkedKeys:[],
      modelName:'',
      dialogVisibleTwo:false,
      autoExpandParent:true,
      dataSourceColunm:[],
      customSlotTwo:[],
      columnsTwo: [
        {
          title: "表名称",
          dataIndex: "name",
            ellipsis: true,
           width: 120,
        },
        {
          title: "操作",
          dataIndex: "title",
          scopedSlots: { customRender: "action" },
         fixed: "right",
          width: 174,
        },
      ],
      visibleTips:false,
      treeData:[],
      submitLoading:false,
      itemData:{},
      deleteShow:false,
      codeData:[],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
        coententTable
  },
  mounted() {},
  methods: {
    closeTwo() {
      this.$emit('closeTwo')
    },
   getTableList(){
      selectList({

      }).then((res)=>{
          if(res.code == 0){
              this.dataSourceColunm = res.data;
          }
      })
    },
    addConfig(){
        this.itemData = {};
        this.checkedKeys = [];
        this.modelName = '';
        this.visibleTips = true;
        this.getList();
    },
    onSelect(e){
        this.checkedKeys = e.checked;
    },
    deleteOne(){
      this.deleteShow = true;
      deleteTable({
        id:this.itemData.id,
      }).then((res)=>{
          if(res.code == 0){
              this.dialogVisibleTwo = false;
              this.deleteShow = false;
              this.getTableList()
          } 
      })  
    },
    updateConfig(item){
      let array = [];
      this.itemData = item;
      selectListUpdate({
          id:item.id,
      }).then((res)=>{
            if(res.code == 0){
                for (let index = 0; index < res.data.length; index++) {
                  const element = res.data[index];
                  array.push(element.organId)
                }
                this.checkedKeys = array;
                this.modelName = item.name;
                this.visibleTips = true;
                this.getList();
            }
      })
       
    },
    handleClose(){
        this.visibleTips = false;
    },
    dele(item){
        this.dialogVisibleTwo = true;
        this.itemData = item;
    },
    submitBtn(){
        if(!this.modelName){
            this.$message.error('请填写表名称');
            return;
        }
        if(this.checkedKeys.length == 0){
            this.$message.error('请填写表名称');
            return;
        }
        this.submitLoading = true;
        if(this.itemData.id){
           update({
              id:this.itemData.id,
              name:this.modelName,
              organIds:this.checkedKeys.join(',')
           }).then((res)=>{
                if(res.code == 0){
                  this.getTableList();
                  this.visibleTips = false;
                  this.checkedKeys = [];
              }
              this.submitLoading = false;
          })
        }else{
             selectListCreate({
              name:this.modelName,
              organIds:this.checkedKeys.join(',')
          }).then((res)=>{
              if(res.code == 0){
                  this.getTableList();
                  this.visibleTips = false;
                  this.checkedKeys = [];
              }
              this.submitLoading = false;
          })
        }
    },
     onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
     getList() {
      this.loading = true;
      tree({
        siteId: sessionStorage.getItem("siteId"),
        columnName:this.value,
      }).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/organizationName/g, "title")
            .replace(/id/g, "key");
          this.treeData = JSON.parse(JSON.stringify(JSON.parse(options)));
          this.expandedKeys = [this.treeData[0].key]
        }
        this.loading = false;
      });
    },
  },
  created() {},
  watch: {
    visible(val) {
      this.visibleTwo = val;
      if(this.visibleTwo){
        this.getTableList()
        this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 10px;
  padding-top: 10px;
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 14px;
}
.el-drawer__close-btn {
  font-size: 14px;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.applay-box {
  padding: 24px;
  padding-bottom: 20px;
  padding-top: 0px;
  padding-bottom: 100px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  width: 80px;
}
.txt-two {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  width: 100%;
}
.txt-box {
  margin-bottom: 20px;
  display: flex;
}
.txt-two-img {
  width: 90px;
  height: 90px;
  margin-right: 14px;
  background: #f6f6f6;
  /deep/ .el-image__inner {
    object-fit: contain;
  }
}
/deep/ .el-descriptions--medium.is-bordered .el-descriptions-item__cell {
  padding: 8px;
  &:first-child {
    width: 120px;
  }
}
.label-box {
  width: 300px;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 16px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
.switch-box{
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  font-family: Roboto-regular;
  margin-top: 8px;
}
.score-box{
  width: 417px;
  max-height: 256px;
  overflow-y: auto;
  border-radius: 4px;
  text-align: left;
  border: 1px solid rgba(220, 223, 230, 1);
  margin-top: -10px;
  padding: 8px;
  padding-top: 0px;
  display: flex;
  justify-content: space-between;
	flex-wrap: wrap;
  /deep/ .el-checkbox__label{
    display: block;
    width: 100%;
    padding-left: 4px;
  }
  /deep/ .el-checkbox__input{
    margin-top: 3px;
  }
  .item {
    width: 42%;
    margin-top: 6px;
    display: flex;
    align-items: center;
    .item-txt{
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        width: 100%;
    }

}
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  background: #fff;
  .form-bottom {
    margin-right: 24px;
    padding: 15px 0px;
  }
}
 .el-button--primary {
  background: #176de6;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.drawer-box{
    /deep/ .table{
        margin: 0px !important;
    }
  
}
 /deep/.el-dialog__title{
        font-weight: bold;
    }
    /deep/ .el-dialog__body{
        padding-top: 0px;
    }
    /deep/ .el-form-item__label{
        text-align: left;
    }
    .tree-box{
        border-radius: 4px;
        background-color: rgba(248, 249, 250, 1);
        color: rgba(16, 16, 16, 1);
        font-size: 14px;
        font-family: Roboto;
        padding: 23px 0px 23px 14px;
        height: 400px;
        overflow-y: auto;
    }
    .dis-box {
        display: flex;
        margin-top: 20px;
        text-align: right;
        justify-content: flex-end;
        }
</style>